import type { ApiError } from "@/api/client";
import { translate } from "@/i18n";
import { hooksMessages } from "@/i18n/messages/hooks";

export function conversationBrowserErrorMessage(error: unknown): string {
  const apiError = error as Partial<ApiError>;
  const serverMessage = apiError.data?.error ?? apiError.data?.detail;
  if (typeof serverMessage === "string") return serverMessage;
  return error instanceof TypeError
    ? translate(hooksMessages, "denkerUnreachable")
    : translate(hooksMessages, "chatsLoadFailed");
}

/** The browser's own states that are not request failures. */
export function conversationBrowserNotice(
  kind: "signInToViewChats" | "offlineNoCachedChats" | "chatNotOffline",
): string {
  return translate(hooksMessages, kind);
}

export function conversationBrowserErrorCode(error: unknown): string | null {
  const code = (error as Partial<ApiError>).data?.code;
  return typeof code === "string" ? code : null;
}

export function conversationBrowserErrorStatus(error: unknown): number | null {
  const status = (error as Partial<ApiError>).status;
  return typeof status === "number" ? status : null;
}
